//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'

//#endregion

import { Enums } from '../../models/common/enums'
import { IUserSession } from '../../helpers/user-session'

import { Api } from './../api/api.module'
import { EventsNames } from './../../helpers/events-names'
import { i18n } from './../common/i18n/common.i18n'

import { OperatorLayoutSetting } from '../../models/local/operator-layout-setting'
import { IMRBaseControlDirectiveController } from '../common/base'

interface Options {
    theme: string
    rtl: boolean
}

interface SettingsScope extends ng.IScope {
    accordionOptions: DevExpress.ui.dxAccordionOptions
    toolbarOptions: DevExpress.ui.dxToolbarOptions

    currentOptions: Options
    selectedOptions: Options
    data: any[]
    isLoading: boolean

    backgroundStyle(mainColor: string, backColor: string): any
}

export class SettingsController extends IMRBaseControlDirectiveController {

    private applyButton: DevExpress.ui.dxButton

    constructor(private $scope: SettingsScope, $timeout: ng.ITimeoutService, private api: Api, protected userSession: IUserSession) {
        super()

        $scope.currentOptions = {
            theme: this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.Theme), window['config'].DEFAULT_THEME),
            rtl: this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.RTL), window['config'].DEFAULT_RTLSTATE)
        }

        $scope.selectedOptions = angular.copy($scope.currentOptions)
        var rtlDataSource = window['config']['RTLSTATE']
        rtlDataSource.forEach(state => {
            state.caption = i18n("Common", state.caption)
        })
        $scope.data = [
            {
                title: i18n('Common', "PageTheme"),
                panel: "pageSettings",
                fields: [
                    {
                        type: 'themeSelectBox',
                        caption: i18n('Common', "Style"),
                        options: {
                            dataSource: window['config']['THEMES'],
                            width: '100%',
                            valueExpr: 'name',
                            displayExpr: 'caption',
                            itemTemplate: 'themeSelectBoxItemTemplate',
                            fieldTemplate: 'themeSelectBoxFieldTemplate',
                            bindingOptions: {
                                value: 'selectedOptions.theme'
                            },
                            noDataText: i18n('Common', 'NoData'),
                            placeholder: i18n('Common', 'Select')
                        }
                    },
                    {
                        type: 'themeSelectBox',
                        caption: i18n('Common', "WritingDirection"),
                        options: {
                            dataSource: rtlDataSource,
                            width: '100%',
                            valueExpr: 'name',
                            displayExpr: 'caption',
                            itemTemplate: 'themeSelectBoxItemTemplate',
                            fieldTemplate: 'themeSelectBoxFieldTemplate',
                            bindingOptions: {
                                value: 'selectedOptions.rtl'
                            },
                            noDataText: i18n('Common', 'NoData'),
                            placeholder: i18n('Common', 'Select')
                        },
                        noColorBox: true

                    }
                ]
            }
        ]

        var accordionData = new DataSource($scope.data)

        $timeout(() => {
            $scope.accordionOptions = {
                height: '100%',
                multiple: false,
                disabled: false,
                collapsible: false,
                dataSource: accordionData,
                itemTemplate: 'panel',
                itemTitleTemplate: 'title',
                noDataText: i18n('Common', 'NoData')
            };
        }
        )

        $scope.toolbarOptions = {
            items: [
                {
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        text: i18n('Common', 'Apply'),
                        onClick: () => {
                            this.updateOptions()
                        },
                        onInitialized: (e) => {
                            this.applyButton = e.component
                        }
                    }
                }
            ]
        }

        $scope.$watch(() => {
            return angular.equals($scope.selectedOptions, $scope.currentOptions)
        }, (value) => {
            if (this.applyButton) this.applyButton.option('disabled', value)
        })

        $scope.backgroundStyle = function (mainColor, backColor) {
            var back = { background: "linear-gradient(to bottom right," + mainColor + "," + backColor + " )" };

            return back
        }
    }

    //#region ng.IController

    public $onInit(): void { }

    //#endregion


    updateOptions() {
        if (this.$scope.selectedOptions.theme != this.$scope.currentOptions.theme) {
            var theme = this.$scope.selectedOptions.theme
            this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.Theme), theme)
            this.$scope.$root.$broadcast(EventsNames.THEME_CHANGE, theme)

        }
        if (this.$scope.selectedOptions.rtl != this.$scope.currentOptions.rtl) {
            this.$scope.isLoading = true
            this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.RTL), this.$scope.selectedOptions.rtl)
        }

        this.$scope.currentOptions = angular.copy(this.$scope.selectedOptions)
        this.$scope.$root.$broadcast(EventsNames.SHOW_LOADING_INDICATOR)
        this.userSession.saveOperatorLayoutSettings(0).then(() => {
            location.reload()
        })
    }

}